import { cn } from '@wwe-portal/ui/lib/lib';

export const TextAvatar: React.FC<{
  text: string;
  className?: string;
}> = ({ text, className }) => {
  return (
    <div
      className={cn(
        'bg-bgColor42 text-inlineTextColor29 text-2xs uppercase md:text-sm',
        className
      )}
    >
      {text.substring(0, 2)}
    </div>
  );
};
